// Island as a connected maze: each of the 22 zones is a room; adjacency is
// derived from the legacy grid coords (xyinfo). Moving N/S/E/W in a room
// transitions to the nearest zone in that direction.

import { ZONES, zoneGrid } from '../sim/JKGame_content'

export type Dir = 'N' | 'S' | 'E' | 'W'
export const DIRS: readonly Dir[] = ['N', 'S', 'E', 'W']

const grids = ZONES.map((z) => zoneGrid(z.coord)) // {col,row}; row increases downward

function buildNeighbors(): Array<Partial<Record<Dir, number>>> {
  const out: Array<Partial<Record<Dir, number>>> = []
  for (let i = 0; i < ZONES.length; i++) {
    const best: Partial<Record<Dir, { z: number; d: number }>> = {}
    for (let j = 0; j < ZONES.length; j++) {
      if (i === j) continue
      const dc = grids[j].col - grids[i].col
      const dr = grids[j].row - grids[i].row
      if (dc === 0 && dr === 0) continue
      const dir: Dir = Math.abs(dc) >= Math.abs(dr) ? (dc > 0 ? 'E' : 'W') : dr > 0 ? 'S' : 'N'
      const dist = Math.abs(dc) + Math.abs(dr)
      const cur = best[dir]
      if (!cur || dist < cur.d) best[dir] = { z: j, d: dist }
    }
    const m: Partial<Record<Dir, number>> = {}
    for (const d of DIRS) if (best[d]) m[d] = best[d]!.z
    out.push(m)
  }
  return out
}

export const NEIGHBORS: ReadonlyArray<Partial<Record<Dir, number>>> = buildNeighbors()

export function neighborOf(zone: number, dir: Dir): number | undefined {
  return NEIGHBORS[zone]?.[dir]
}

export function opposite(dir: Dir): Dir {
  return dir === 'N' ? 'S' : dir === 'S' ? 'N' : dir === 'E' ? 'W' : 'E'
}
